import React, {useState}                                                      from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material'
import SelectCategory                                                         from "./SelectCategory"
import SelectLlmModel                                                         from "./SelectLlmModel"
import PromptTemplatePicker                                                   from "./PromptTemplatePicker"
import SelectProductType                                                      from "./SelectProductType"

const EditProductModal = ({ open, product, onClose, onSave }) => {
	const [name, setName] = useState(product.name || '')
	const [shortName, setShortName] = useState(product.short_name || '')
	const [token, setToken] = useState(product.token || '')
	const [llmModel, setLlmModel] = useState(product.llm_model || null)
	const [category, setCategory] = useState(product.category_id || null)
	const [productType, setProductType] = useState(product.product_type || '')
	const [topicPrompt, setTopicPrompt] = useState(product.topic_prompt || '')
	const [questionPrompt, setQuestionPrompt] = useState(product.question_prompt || '')

	const handleSave = () => {
		const update = { name, shortName, token, category, llmModel, topicPrompt, questionPrompt, productType }
		onSave(update)
		onClose() // Close modal after saving
	}

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Edit Product</DialogTitle>
			<DialogContent>
				<TextField
					label="Name"
					fullWidth
					value={name}
					onChange={(e) => setName(e.target.value)}
					margin="normal"
				/>
				<SelectCategory sx={{mt: 1}} category={category} onChangeCategory={(c)=>setCategory(c.id)}/>
				<SelectProductType sx={{mt: 2}}
				                   productType={productType}
				                   onChangeProductType={setProductType}
				/>
				<TextField
					label="Short Name"
					fullWidth
					value={shortName}
					onChange={(e) => setShortName(e.target.value)}
					margin="normal"
				/>
				<TextField
					label="URL Token"
					fullWidth
					value={token}
					onChange={(e) => setToken(e.target.value)}
					margin="normal"
				/>
				<SelectLlmModel sx={{mt: 1}}
				                llmModel={llmModel}
				                onChangeLlmModel={(m)=>setLlmModel(m.name)}
				/>
				<Typography variant="subtitle2" sx={{ mt: 2, mb: 0.5 }}>Topic Prompt</Typography>
				<PromptTemplatePicker type="topic" onSelect={body => setTopicPrompt(body)} />
				<TextField
					label="Topic Prompt"
					fullWidth
					multiline
					rows={6}
					value={topicPrompt}
					onChange={(e) => setTopicPrompt(e.target.value)}
					margin="normal"
					InputProps={{ sx: { fontFamily: 'monospace', fontSize: 12 } }}
				/>
				<Typography variant="subtitle2" sx={{ mt: 1, mb: 0.5 }}>Question Prompt</Typography>
				<PromptTemplatePicker type="question" onSelect={body => setQuestionPrompt(body)} />
				<TextField
					label="Question Prompt"
					fullWidth
					multiline
					rows={6}
					value={questionPrompt}
					onChange={(e) => setQuestionPrompt(e.target.value)}
					margin="normal"
					InputProps={{ sx: { fontFamily: 'monospace', fontSize: 12 } }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>
					Cancel
				</Button>
				<Button variant="contained" color="primary" onClick={handleSave}>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditProductModal
